import gsap from 'gsap';
import * as scenesDataJson from '../data/scenes-data.json';
import Utils from '../utils.js';

const poiComponent = {
  schema: {
    poiElement: { // DOM element to enable
      type: 'string',
      default: '',
    },
    sceneDataKey: { // Key from JSON config file
      type: 'string',
      default: '',
    },
    poiDataKey: { // Key from JSON config file
      type: 'string',
      default: '',
    },
    delayAfterClick: {
      default: false,
    },
    disableAfterInteract: {
      default: false,
    },
  },

  init() {
    this.debug = Utils.paramIsEnabled('debug');
    this.poiHudElement = document.querySelector(this.data.poiElement);
    this.poiHudElement.poiComponentReference = this;
    this.poiData = scenesDataJson.scenes[this.data.sceneDataKey].pois[this.data.poiDataKey];
    if (this.poiData.unlockedWith) {
      this.el.poiIsLocked = true;
    }
    // console.log('poiComponent init() - this:', this, ', this.poiData:', this.poiData);
    this.pieChartSoundElement = document.querySelector('#pieChartSoundElement');
    //console.log('poiComponent init() - this.data:', this.data, '\nthis:', this, '\nthis.el.components', this.el.components);
    // this.reticleFocused = this.el.querySelector('.reticleFocused');

    /*this.fuseEffect = document.querySelector('#poi-fuse-effect').cloneNode(true);
    this.el.appendChild(this.fuseEffect);
    this.fuseEffectRippleChild1 = this.fuseEffect.querySelector('.cursorRippleChild1');
    this.fuseEffectRippleChild2 = this.fuseEffect.querySelector('.cursorRippleChild2');
    this.fuseEffectSpinParent = this.fuseEffect.querySelector('#spinParent');
    this.fuseEffectSpinChild1 = this.fuseEffect.querySelector('.spinChild1');
    this.fuseEffectSpinChild2 = this.fuseEffect.querySelector('.spinChild2');
    this.fuseEffectSpinChild3 = this.fuseEffect.querySelector('.spinChild3');
    this.fuseEffectSpinChild4 = this.fuseEffect.querySelector('.spinChild4');
    const spinChildren = [this.fuseEffectSpinChild1, this.fuseEffectSpinChild2, this.fuseEffectSpinChild3, this.fuseEffectSpinChild4];
    for (let i = 0; i < spinChildren.length; i++) {
      gsap.fromTo(spinChildren[i].object3D.scale,
        {
          x: 0, y: 0, z: 0,
        },
        {
          x: 1,
          y: 1,
          z: 1,
          duration: 1,
          ease: 'sine.inOut',
          delay: 0.5 * i,
          repeat: -1,
          yoyo: true,
        },
      );
    }*/

    // this.setEnabled(false);
    this.createSoundElements();
    setTimeout(() => {
      // this.setHighlight(false, true);
      // this.el.object3D.scale.set(0, 0, 0);
    }, 500);

    if (this.debug) {
      const debugCube = new THREE.Mesh(
        new THREE.BoxGeometry(1, 1, 1),
        new THREE.MeshBasicMaterial({ color: 0x00aaff, wireframe: true }),
      );
      this.el.object3D.add(debugCube);
    }

    this.subscribeToEvents();

    // this.appearTween();
    this.alreadyAppeared = true;
  },

  subscribeToEvents() {
    this.el.addEventListener('fusing', this.pointFusing.bind(this));
    this.el.addEventListener('click', this.pointClicked.bind(this));
    this.el.addEventListener('mouseleave', this.pointLeave.bind(this));
    this.el.sceneEl.addEventListener('sceneChanged', this.sceneChanged.bind(this));
    this.el.sceneEl.addEventListener('interactedWithPoi', this.interactedWithPoi.bind(this));
  },

  pointFusing() {
    this.setHighlight(true);
    // Sound:
    this.playHoverSound();
    // Particles:
    if (this.poiData.hoverParticles) {
      if (!this.hoverParticlesElement) {
        this.hoverParticlesElement = document.querySelector(this.poiData.hoverParticles);
      }
      this.hoverParticlesElement.components['particle-system'].startParticles();
    }
  },

  pointClicked() {
    if (this.el.poiIsLocked) {
      this.playLockedSound();
      this.showLockedIcon();
      if (this.poiData.lockedMessage) {
        this.el.sceneEl.emit('showMessage', {
          title: this.poiData.messageTitle || '',
          message: this.poiData.lockedMessage,
        }, false);
      }
    }
    else {
      this.isClicked = true;
      //window.gameManager.setAllPoisEnabled(false); // Hide all POI first
      window.gameManager.CurrentPoi = this.data.poiDataKey;

      // Sound:
      this.playActiveSound();

      setTimeout(() => {
        // window.cameraHudComponent.showPoi(this.poiHudElement);
        this.setHighlight(false);
        if (this.poiData.nextSceneId) {
          this.el.sceneEl.emit('changeScene', { newScene: this.poiData.nextSceneId }, false);
          this.isClicked = false;
        }
      }, this.data.delayAfterClick ? 1700 : 300);

      this.el.sceneEl.emit('interactedWithPoi', { sceneDataKey: this.data.sceneDataKey, poiDataKey: this.data.poiDataKey }, false);
      if (this.data.disableAfterInteract) {
        this.setEnabled(false);
      }
    }
  },

  closePoint() {
    this.isClicked = false;
    //window.gameManager.setAllPoisEnabled(true);
    window.cameraHudComponent.showHidePoi(this.poiHudElement, false);
    this.el.sceneEl.emit('poiClosed', {}, false);
  },

  pointLeave() {
    if (this.isClicked) return;
    this.setHighlight(false);
    this.stopHoverSound();
    if (this.poiData.hoverParticles) {
      if (!this.hoverParticlesElement) {
        this.hoverParticlesElement = document.querySelector(this.poiData.hoverParticles);
      }
      this.hoverParticlesElement.components['particle-system'].stopParticles();
    }
  },

  setHighlight(newStatus = true, instant = false) {
    const ripplesTweenDuration = 1500;
    //console.log('setHighlight - this.el:', this.el);
    /*gsap.killTweensOf(this.el.components.material.material); ///////
    gsap.to(this.el.components.material.material, {
      opacity: newStatus ? 0 : 1,
      duration: instant ? 0 : 0.4,
      ease: 'power2.out',
    });*/
    // console.log('setHighlight() - newStatus:', newStatus, ', material', this.el.components.material);
    /*if (this.alreadyAppeared) {
      this.el.setAttribute('animation__scale', {
        property: 'scale',
        to: `${newStatus ? 1.2 : 1} ${newStatus ? 1.2 : 1} ${newStatus ? 1.2 : 1}`,
        easing: newStatus ? 'easeOutBack' : 'easeOutSine',
        dur: 350,
      });
    }*/
    // this.reticleFocused.components.material.material.opacity = newStatus ? 1 : 0;
    if (this.fuseEffect) {
      // Enable orbs:
      this.fuseEffect.setAttribute('visible', true);
      // Alpha:
      const allElementsAlpha = [this.fuseEffectSpinChild1, this.fuseEffectSpinChild2, this.fuseEffectSpinChild3, this.fuseEffectSpinChild4];
      if (!newStatus) allElementsAlpha.push(this.fuseEffectRippleChild1, this.fuseEffectRippleChild2);
      for (let i = 0; i < allElementsAlpha.length; i++) {
        //console.log('setHighlight - allElementsAlpha[i]:', allElementsAlpha[i].classList, ' - material:', allElementsAlpha[i].components.material.material);
        gsap.killTweensOf(allElementsAlpha[i].components.material.material); ///////
        gsap.to(allElementsAlpha[i].components.material.material, {
          opacity: newStatus ? 1 : 0,
          duration: instant ? 0 : 0.4,
          ease: 'power2.out',
        });
      }
      // Tween:
      const fuseEffectRippleChildren = [this.fuseEffectRippleChild1, this.fuseEffectRippleChild2];
      if (newStatus) {
        for (let i = 0; i < fuseEffectRippleChildren.length; i++) {
          // console.log('setHighlight - fuseEffectRippleChildren[i]:', fuseEffectRippleChildren[i].object3D);
          gsap.killTweensOf(fuseEffectRippleChildren[i].object3D.scale); ///////
          gsap.fromTo(fuseEffectRippleChildren[i].object3D.scale,
            {
              x: 0, y: 0, z: 0,
            },
            {
              x: 1,
              y: 1,
              z: 1,
              duration: instant ? 0 : ripplesTweenDuration * 0.001,
              ease: 'power2.out',
              delay: ((ripplesTweenDuration * 0.001) / fuseEffectRippleChildren.length) * i,
              repeat: -1,
            },
          );
          gsap.fromTo(fuseEffectRippleChildren[i].components.material.material,
            {
              opacity: 1,
            },
            {
              opacity: 0,
              duration: ripplesTweenDuration * 0.001,
              ease: 'power2.in',
              delay: ((ripplesTweenDuration * 0.001) / fuseEffectRippleChildren.length) * i,
              repeat: -1,
            },
          );
        }
        this.fuseEffectSpinParent.setAttribute('animation__rotation', {
          property: 'rotation',
          from: '0 0 0',
          to: '0 0 360',
          easing: 'linear',
          dur: 5000,
          loop: true,
        });
      }
    }
  },

  setEnabled(newStatus = true) {
    gsap.to(this.el.components.material.material, {
      opacity: newStatus ? 1 : 0,
      duration: 0.3,
      ease: 'sine.inout',
      onStart: () => {
        if (newStatus) {
          this.el.setAttribute('visible', true);
        }
        else {
          this.el.classList.remove('raycastInteractable');
        }
      },
      onComplete: () => {
        if (newStatus) {
          this.el.classList.add('raycastInteractable');
        }
        else {
          // this.el.setAttribute('visible', false);
        }
      },
    });
  },

  appearTween(playSound = false) {
    this.alreadyAppeared = true;
    if (playSound) this.playAppearSound();
    gsap.fromTo(this.el.object3D.scale,
      {
        x: 0, y: 0, z: 0,
      },
      {
        x: 1,
        y: 1,
        z: 1,
        duration: 1.7,
        ease: 'elastic.out',
        onStart: () => {
          this.el.setAttribute('visible', true);
        },
        onComplete: () => {
          this.el.classList.add('raycastInteractable');
        },
      },
    );
  },

  sceneChanged(e) {
    //console.log('sceneChanged() e:', e);
    // Check if interaction should be enabled
    //console.log('sceneChanged - e.detail.newScene:', e.detail.newScene, ', this.data.sceneDataKey:', this.data.sceneDataKey);
    if (e.detail.newScene === this.data.sceneDataKey) {
      this.el.object3D.scale.set(1, 1, 1);
    }
    else {
      this.el.object3D.scale.set(0, 0, 0);
    }
  },

  interactedWithPoi(e) {
    // console.log('interactedWithPoi() e.detail:', e.detail);
    if (this.poiData.unlockedWith) {
      // console.log('interactedWithPoi - this.poiData.unlockedWith:', this.poiData.unlockedWith);
      // console.log('interactedWithPoi - e.detail.sceneDataKey:', e.detail.sceneDataKey, '===', this.poiData.unlockedWith.scene);
      // console.log('interactedWithPoi - e.detail.poiDataKey:', e.detail.poiDataKey, '===', this.poiData.unlockedWith.poi);
      if (e.detail.sceneDataKey === this.poiData.unlockedWith.scene && e.detail.poiDataKey === this.poiData.unlockedWith.poi) {
        this.el.poiIsLocked = false;
      }
    }
  },

  // Sound >>>
  createSoundElements() {
    // POI orb appear sound:
    this.orbAppearSoundElement = document.createElement('a-entity');
    this.orbAppearSoundElement.originalVolume = 0.7;
    this.orbAppearSoundElement.setAttribute('sound', {
      src: '#poiAppearSound',
      autoplay: false,
      loop: false,
      positional: false,
      distanceModel: 'linear',
      refDistance: 1,
      rolloffFactor: 0.1,
      volume: this.orbAppearSoundElement.originalVolume,
    });
    this.el.appendChild(this.orbAppearSoundElement);
    // POI orb hover sound:
    /*this.orbHoverSoundElement = document.createElement('a-entity');
    this.orbHoverSoundElement.originalVolume = 0.6;
    this.orbHoverSoundElement.setAttribute('sound', {
      src: '#poiHoverSound',
      autoplay: false,
      loop: false,
      positional: false,
      distanceModel: 'linear',
      refDistance: 1,
      rolloffFactor: 0.1,
      volume: this.orbHoverSoundElement.originalVolume,
    });
    this.el.appendChild(this.orbHoverSoundElement);*/

    this.lockedIconElement = document.createElement('a-plane');
    this.lockedIconElement.setAttribute('visible', false);
    this.lockedIconElement.setAttribute('width', 3.3);
    this.lockedIconElement.setAttribute('height', 3.3);
    // this.lockedIconElement.object3D.position.set(0, 0, 0.1);
    this.lockedIconElement.setAttribute('material', {
      shader: 'flat',
      transparent: true,
      side: 'double',
    });
    this.lockedIconElement.setAttribute('src', '#lock-icon-texture');
    this.lockedIconElement.setAttribute('draw-on-top', {
      renderOrder: 1,
    });
    this.el.appendChild(this.lockedIconElement);

    // Custom sounds:
    if (this.poiData.hoverSound) {
      this.hoverSoundElement = document.createElement('a-entity');
      this.hoverSoundElement.setAttribute('sound', {
        src: this.poiData.hoverSound,
        autoplay: false,
        loop: false,
        positional: false,
        distanceModel: 'linear',
        refDistance: 1,
        rolloffFactor: 0.1,
      });
      this.el.appendChild(this.hoverSoundElement);
    }
    if (this.poiData.activeSound) {
      this.activeSoundElement = document.createElement('a-entity');
      this.activeSoundElement.originalVolume = 0.6;
      this.activeSoundElement.setAttribute('sound', {
        src: this.poiData.activeSound,
        autoplay: false,
        loop: false,
        positional: false,
        distanceModel: 'linear',
        refDistance: 1,
        rolloffFactor: 0.1,
      });
      this.el.appendChild(this.activeSoundElement);
    }
    if (this.poiData.lockedSound) {
      this.lockedSoundElement = document.createElement('a-entity');
      this.lockedSoundElement.setAttribute('sound', {
        src: this.poiData.lockedSound,
        autoplay: false,
        loop: false,
        positional: false,
        distanceModel: 'linear',
        refDistance: 1,
        rolloffFactor: 0.1,
      });
      this.el.appendChild(this.lockedSoundElement);
    }
  },

  playHoverSound() {
    if (this.orbHoverSoundElement && this.orbHoverSoundElement.components.sound) {
      this.orbHoverSoundElement.components.sound.pool.children[0].setVolume(this.orbHoverSoundElement.originalVolume);
      this.orbHoverSoundElement.components.sound.stopSound();
      this.orbHoverSoundElement.components.sound.playSound();
    }

    if (this.hoverSoundElement) {
      if (this.hoverSoundFadeTwn) this.hoverSoundFadeTwn.kill();
      this.hoverSoundElement.components.sound.pool.children[0].setVolume(1);
      this.hoverSoundElement.components.sound.stopSound();
      this.hoverSoundElement.components.sound.playSound();
    }
  },

  playAppearSound() {
    this.orbAppearSoundElement.components.sound.pool.children[0].setVolume(this.orbAppearSoundElement.originalVolume);
    this.orbAppearSoundElement.components.sound.stopSound();
    this.orbAppearSoundElement.components.sound.playSound();
  },

  stopHoverSound() {
    if (this.hoverSoundElement) {
      // TODO Fade volume first
      const t = { value: this.hoverSoundElement.components.sound.data.volume };
      this.hoverSoundFadeTwn = gsap.to(t, {
        value: 0,
        duration: 0.5,
        ease: 'power1.out',
        onUpdate: () => {
          this.hoverSoundElement.components.sound.pool.children[0].setVolume(t.value);
        },
        onComplete: () => {
          this.hoverSoundElement.components.sound.stopSound();
        },
      });
    }
  },

  playActiveSound() {
    if (this.activeSoundElement) {
      if (this.activeSoundFadeTwn) this.activeSoundFadeTwn.kill();
      this.activeSoundElement.components.sound.pool.children[0].setVolume(this.activeSoundElement.originalVolume);
      this.activeSoundElement.components.sound.stopSound();
      this.activeSoundElement.components.sound.playSound();
    }
  },

  stopActiveSound() {
    if (this.activeSoundElement) {
      // TODO Fade volume first
      const t = { value: this.activeSoundElement.components.sound.data.volume };
      this.activeSoundFadeTwn = gsap.to(t, {
        value: 0,
        duration: 0.5,
        ease: 'power1.out',
        onUpdate: () => {
          this.activeSoundElement.components.sound.pool.children[0].setVolume(t.value);
        },
        onComplete: () => {
          this.activeSoundElement.components.sound.stopSound();
        },
      });
    }
  },

  showLockedIcon() {
    if (this.lockedIconElement) {
      if (this.lockedIconFadeTwn) this.lockedIconFadeTwn.kill();
      this.lockedIconFadeTwn = gsap.fromTo(this.lockedIconElement.object3D.scale,
        {
          x: 0, y: 0, z: 0,
        },
        {
          x: 1,
          y: 1,
          z: 1,
          duration: 0.4,
          ease: 'back.out',
          onStart: () => {
            this.lockedIconElement.setAttribute('visible', true);
          },
          onComplete: () => {
            this.lockedIconFadeTwn = gsap.to(this.lockedIconElement.object3D.scale,
              {
                x: 0, y: 0, z: 0,
                duration: 0.4,
                delay: 1,
                ease: 'power2.in',
                onComplete: () => {
                  this.lockedIconElement.setAttribute('visible', false);
                },
              },
            );
          },
        },
      );
    }
  },

  playLockedSound() {
    if (this.lockedSoundElement) {
      if (this.lockedSoundFadeTwn) this.lockedSoundFadeTwn.kill();
      this.lockedSoundElement.components.sound.pool.children[0].setVolume(1);
      this.lockedSoundElement.components.sound.stopSound();
      this.lockedSoundElement.components.sound.playSound();
    }
  },
  // <<< Sound
};

export default poiComponent;
